import React from "react";
import styled from "styled-components";
import MediaQuery from "react-responsive";

import CountryNavigator from "../components/CountryNavigator";
import MainContent from "../components/MainContent";
import SideNavigation from "../components/UI/SideNavigation";

const Container = styled.div`
  max-width: 64rem;
  margin: auto;
  width: 100%;
  height: 100%;
  @media screen and (max-width: 64em) {
    width: calc(100vw - 4rem);
  }
  @media screen and (max-width: 20em) {
    width: calc(100vw - 2rem);
  }
`;

const MainWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
`;

const Nordics = props => {
  return (
    <Container>
      <CountryNavigator
        countries={props.data.countryList.edges.map(e => e.node)}
        currentId={props.pathContext.id}
      />
      <MainWrapper>
        <MediaQuery query="(min-width: 48em)">
          <SideNavigation
            contentCategories={props.data.getCountryContent.categories}
          />
        </MediaQuery>
        <MainContent
          contentCategories={props.data.getCountryContent.categories}
        />
      </MainWrapper>
    </Container>
  );
};

export const NordicsQuery = graphql`
  query NordicsCountryQuery($id: String) {
    countryList: allCountry {
      edges {
        node {
          id
          name
          icon {
            url
            handle
          }
        }
      }
    }
    getCountryContent: country(id: { eq: $id }) {
      id
      name
      categories {
        title
        articles {
          title
          body
        }
      }
    }
  }
`;

export default Nordics;



// WEBPACK FOOTER //
// ./src/templates/CountryPage.js